import React from 'react'
import { Field } from 'redux-form'
import { Button } from 'react-bootstrap'
import { getNumericValidator } from '../../../Forms/fieldValidators'
import { renderTextField } from '../../../Forms/fieldRenderers'
import CamposPesado0 from '../../components/pesado/CamposPesado0'

const numeric12 = getNumericValidator(9, 12)

function PesadoDestareAuto (props) {
  const { pesadoEnCabina, onBlurInput, handleSubmit } = props

  const validate = [numeric12]

  return (
    <>
      <div className='container-peso-cabezal'>
        <Field
          className='peso-cabezal'
          name='pesoDestare'
          component={renderTextField}
          disabled
          label='Peso tara'
          autoFocus
        />
      </div>

      <div className='campos-cea-destare'>
        { (!pesadoEnCabina)
          ? <CamposPesado0
            validate={validate}
            label='Número de CTG'
            disabled={!pesadoEnCabina}
            onBlurInput={onBlurInput}
          />
          : <form onSubmit={handleSubmit}>
            <CamposPesado0
              validate={validate}
              label='Número de CTG'
              disabled={!pesadoEnCabina}
              onBlurInput={onBlurInput}
            />
            <div>
              <Button
                className='btn-pesado-destare'
                type='submit'
                size='lg'
                style={{ visibility: 'hidden', display: 'none' }}
              >
                            Siguiente
              </Button>
            </div>
          </form>
        }
      </div>
    </>
  )
}

export default PesadoDestareAuto
